var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 16H19V21M10 8H5.00003V3M19.418 9.003C18.8574 7.61519 17.9186 6.41251 16.7084 5.53166C15.4983 4.65082 14.0653 4.12714 12.5723 4.02016C11.0793 3.91318 9.5863 4.22718 8.26291 4.92648C6.93952 5.62577 5.83886 6.68231 5.08603 7.976M4.58203 14.997C5.14283 16.3846 6.0816 17.587 7.29166 18.4676C8.50172 19.3483 9.93455 19.8718 11.4273 19.9788C12.9201 20.0858 14.4129 19.7719 15.7362 19.0728C17.0595 18.3737 18.1601 17.3174 18.913 16.024",
    className: "svgStroke",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.ac1c5224d5eed60f59c45c1f6a802165.svg";
export { ForwardRef as ReactComponent };